import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddLicense from '../../components/CustomerDetails/AddLicense';
import { licenseMessages, loggerEventOutcome, loggerEventTypes, loggerEventName } from '../../helpers/messages';
import { validateLicenseFields, validateAlphanumeric, validateEndDate, validateStartDate } from './ValidateCustomer';
import { saveLicenseDetails } from '../../services/java/java-services';
import { logger } from '../../services/logger/logger-service';
import { licenseTypes } from '../../helpers/constants';
let startDate;
class AddLicenseContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			licenseTypeObj: licenseTypes,
			licenseStartDate: '',
			licenseEndDate: '',
			duration: '',
			poNumber: '',
			showErrorMsg: '',
			showLicenseErr: '',
			isLoading: false,
			licenseType: '',
			errors: {
				licenseStartDate: '',
				licenseEndDate: '',
				poNumber: '',
				licenseType: '',
			}
		}
	}
	componentDidMount() {
		// initialize the start date on page load
		startDate = new Date();
		window.addEventListener('beforeunload', this.applicationLogger);
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.applicationLogger);
		this.applicationLogger();
	}

	/**
	 * @description function to handle application logs
	 * @param {*}
	 * @memberof AddLicenseContainer
	 */
	applicationLogger(key) {
		// calculate the time since we loaded this page
		const timeSinceLoad = (new Date().getTime() - startDate.getTime()) / 1000;
		const loggerObj = {
			"EventOutcome": loggerEventOutcome.success,
			"EventType": loggerEventTypes.read,
			"EventName": loggerEventName.addNewLicense,
			"Content": {
				"TimeSpent": timeSinceLoad
			}
		}
		logger(loggerObj);
	}


	/**
	 * @description Function to handle input changes
	 * @param  value Value of the input
	 * @param  field Input field name
	 * @memberof AddLicenseContainer
	 */
	handleInputChange = (field, value) => {
		this.setState({ showErrorMsg: '' });
		var errorMessage = value ? '' : licenseMessages[field];
		var dateRangeErrorMessages = {};

		if (field === 'poNumber' && value) {
			const poNumberCheck = validateAlphanumeric(value);
			errorMessage = poNumberCheck.error;
		}
		if (field === 'poNumber' && value === '') {
			errorMessage = '';
		}

		if (field === 'licenseEndDate' && value) {
			const licenseEndDateCheck = validateEndDate(this.state.licenseStartDate, value);
			errorMessage = licenseEndDateCheck.error;
			if (!licenseEndDateCheck.errorFlag) {
				dateRangeErrorMessages = { licenseStartDate: '' }
			}
		}

		if (field === 'licenseStartDate' && value && this.state.licenseEndDate) {
			const licenseStartDateCheck = validateStartDate(value, this.state.licenseEndDate);
			errorMessage = licenseStartDateCheck.error;
			if (!licenseStartDateCheck.errorFlag) {
				dateRangeErrorMessages = { licenseEndDate: '' }
			}
		}

		this.setState(prevState => {
			return {
				[field]: value,
				errors: {
					...prevState.errors,
					...dateRangeErrorMessages,
					[field]: errorMessage
				}
			}
		});
	}

	/** 
	 * @description Function submit form by hitting enter key
	 *  @param e Keypress event
	 *  @memberof AddLicenseContainer
	 */
	onEnterPress = (e) => {
		if (e.which === 13) {
			e.preventDefault();
			this.saveLicense();
		}
	}

	/**
	 * @description Function to validate fields at the time of submit
	 * @returns Boolean value if there are any errors
	 * @memberof AddLicenseContainer
	 */
	validateFields = () => {
		let { errorFlag, errors } = validateLicenseFields(this.state);
		if (!errorFlag && this.state.poNumber) {
			let poNumber = validateAlphanumeric(this.state.poNumber);
			errorFlag = poNumber.errorFlag;
		}

		if (!errorFlag && this.state.licenseStartDate && this.state.licenseEndDate) {
			let licenseStartDateCheck = validateStartDate(this.state.licenseStartDate, this.state.licenseEndDate);
			errorFlag = licenseStartDateCheck.errorFlag;
			errors['licenseStartDate'] = licenseStartDateCheck.error;
		}

		if (!errorFlag && this.state.licenseEndDate) {
			let licenseEndDateCheck = validateEndDate(this.state.licenseStartDate, this.state.licenseEndDate);
			errorFlag = licenseEndDateCheck.errorFlag;
			errors['licenseEndDate'] = licenseEndDateCheck.error;
		}

		if (errorFlag) {
			this.setState(prevState => {
				return {
					errors: {
						...prevState.errors,
						...errors
					}
				}
			})
		}
		return errorFlag;
	}

	/**
	 * @description function to validate and save the license details
	 * @param {*}
	 * @memberof AddLicenseContainer
	 */
	saveLicense = () => {
		this.setState({ showErrorMsg: '' });
		const formHasErrors = this.validateFields();
		if (!formHasErrors) {
			this.setState({ isLoading: true });
			const getLicenseDetails = {
				"startDate": this.state.licenseStartDate,
				"endDate": this.state.licenseEndDate,
				"po": this.state.poNumber,
				"customerId": this.props.customerId,
				"licenseType": this.state.licenseType,
			}
			saveLicenseDetails(getLicenseDetails, (err, result) => {
				if (err) {
					this.setState({ showErrorMsg: err.message, isLoading: false, showLicenseErr: err });
				} else {
					this.resetInputs();
					this.props.refreshLicenseDataList(true);
					this.props.cancelAction();
					this.setState({ isLoading: false, showLicenseErr: null });
				}
			})
		}
	}
	/** @description function to clear inputs
	 *  @param  {}
	 *  @memberof AddLicenseContainer
	 */
	resetInputs = () => {
		this.setState({ licenseStartDate: '', licenseEndDate: '', licenseType: '', poNumber: '' });
	}

	render() {
		return (
			<AddLicense
				licenseStartDate={this.state.licenseStartDate}
				formErrors={this.state.errors}
				handleInputChange={this.handleInputChange}
				onEnterPress={this.onEnterPress}
				saveLicense={this.saveLicense}
				cancelAction={this.props.cancelAction}
				showErrorMsg={this.state.showErrorMsg}
				isLoading={this.state.isLoading}
				showLicenseErr={this.state.showLicenseErr}
				licenseTypeObj={this.state.licenseTypeObj} />
		);
	}
}

function mapStateToProps(state) {
	return {
		state,
	};
}

export default connect(mapStateToProps)(AddLicenseContainer);